export default __webpack_public_path__ + "static/logo-fedabf837dfc83674c3b00abd834c902.svg";